export default class Ajax {

  constructor (props) {
    this.uri = props.uri
    this.callback = (res) => console.info(res)
  }

  setCallback (func) {
    this.callback = func
  }

  send (request) {
    var xhttp = new XMLHttpRequest()
    const callback = this.callback

    xhttp.open('POST', this.uri + '/server/router.php', true)
    xhttp.setRequestHeader('Content-Type', 'application/json')
    
    xhttp.onreadystatechange = function () {
      if (this.readyState === 4 && this.status == 200) {
  
        callback(JSON.parse(this.responseText))
        
      }
    }
  
    xhttp.send(JSON.stringify(request))
  }


}
